import { Features, isEnabled } from '../../../../models/features'
import { Countries } from '../../../../models/countries'
import bankidSE from '../../../../assets/img/bankid_.svg'
import mitidDK from '../../../../assets/img/mitid.svg'
import tupasFI from '../../../../assets/img/tupas.svg'
import bankidNO from '../../../../assets/img/no_bankid.svg'
import bankid from '../../../../assets/img/bankid.svg'
import { getText } from '../../../../internal/TextLabels'

export const getBankIDLogoFromCountryCode = countryCode => {
  switch (countryCode) {
    case Countries.SE:
      return bankidSE
    case Countries.DK:
      return mitidDK
    case Countries.FI:
      return tupasFI
    case Countries.NO:
      return bankidNO
    default:
      return bankid
  }
}

const blockedCardRanges = [
  { length: 2, min: 51, max: 55 }, // MasterCard
  { length: 4, min: 2221, max: 2720 }, // MasterCard
]

const isBetween = (value, { min, max }) => min <= value && max >= value

const isBlocked = cardNumber =>
  blockedCardRanges.some(range =>
    isBetween(cardNumber.substring(0, range.length), range),
  )

// MasterCards should display accountNumbers instead of cardNumbers (which are assumed to start with either '51'-'55' or '2221'-'2720') MPSE-3668
export const getCardOrAccountNumber = ({ cardNumber, accountNumber }) => {
  const cardOrAccount = cardNumber || accountNumber
  if (isEnabled(Features.VIRTUAL_CARD)) {
    return cardOrAccount
  }
  return isBlocked(cardOrAccount) ? accountNumber : cardOrAccount
}

export const InfoLineType = {
  CURRENCY: 'CURRENCY',
  PERCENTAGE: 'PERCENTAGE',
  MONTH: 'MONTH',
}

export const InfoLineKeys = {
  DURATION_IN_MONTHS: 'DURATION_IN_MONTHS',
  CREDIT_AMOUNT: 'CREDIT_AMOUNT',
  INTEREST: 'INTEREST',
  MONTHLY_ADMIN_FEE: 'MONTHLY_ADMIN_FEE',
  NORMAL_MONTHLY_REPAYMENT_AMOUNT: 'NORMAL_MONTHLY_REPAYMENT_AMOUNT',
  EFFECTIVE_INTEREST: 'EFFECTIVE_INTEREST',
  ARRANGEMENT_FEE: 'ARRANGEMENT_FEE',
  CREDIT_COST: 'CREDIT_COST',
  TOTAL_LOAN_COST: 'TOTAL_LOAN_COST',
}

export const InfoLineProperties = {
  [InfoLineKeys.DURATION_IN_MONTHS]: {
    label: getText('payApply.paymentPerMonth.durationInMonths'),
    type: InfoLineType.MONTH,
    decimals: 0,
  },
  [InfoLineKeys.CREDIT_AMOUNT]: {
    label: getText('payApply.paymentPerMonth.creditAmount'),
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.INTEREST]: {
    label: getText('payApply.paymentPerMonth.interest'),
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.MONTHLY_ADMIN_FEE]: {
    label: getText('payApply.paymentPerMonth.monthlyAdminFee'),
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.NORMAL_MONTHLY_REPAYMENT_AMOUNT]: {
    label: getText('payApply.paymentPerMonth.normalMonthlyRepaymentAmount'),
    type: InfoLineType.CURRENCY,
    reservations: 1,
  },
  [InfoLineKeys.EFFECTIVE_INTEREST]: {
    label: getText('payApply.paymentPerMonth.effectiveInterest'),
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.ARRANGEMENT_FEE]: {
    label: getText('payApply.paymentPerMonth.arrangementFee'),
    type: InfoLineType.CURRENCY,
    reservations: 2,
  },
  [InfoLineKeys.CREDIT_COST]: {
    label: getText('payApply.paymentPerMonth.creditCost'),
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.TOTAL_LOAN_COST]: {
    label: getText('payApply.paymentPerMonth.totalLoanCost'),
    type: InfoLineType.CURRENCY,
  },
}
